let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fez3i")).then(() => parcelRequire('btvWF'));